// import moment from 'moment'
import { apiPaths, urls } from '../../config'
import { http, notification } from '../../services/index'
import { factorySetStateAction } from '../factory'

// Defined Device Constants to bind SAGA functions with Redux Dispatcher
const actions = {
  GET_DEVICE_SESSIONS: 'device/GET_DEVICE_SESSIONS',
  SET_STATE: 'device/SET_STATE',
  GET_DEVICE_ACTIVITY: 'device/GET_DEVICE_ACTIVITY',
  GET_CLINIC_DEVICE_ACTIVITY: 'device/GET_CLINIC_DEVICE_ACTIVITY',
  ADD_DEVICE: 'device/ADD_DEVICE',
  GET_INVENTORY_DEVICES: 'device/GET_INVENTORY_DEVICES',
  UPDATE_DEVICE: 'device/UPDATE_DEVICE',
  ADD_DEVICE_INVENTORY: 'device/ADD_DEVICE_INVENTORY',
  DELETE_INVENTORY_DEVICE: 'device/DELETE_INVENTORY_DEVICE',
  ASSIGN_DEVICE_TO_USER: 'device/ASSIGN_DEVICE_TO_USER',
  GET_DEVICE_DETAIL: 'device/GET_DEVICE_DETAIL',
  GET_DEVICE_SLEEP_STAGES_HISTORY: 'device/GET_DEVICE_SLEEP_STAGES_HISTORY',
  DEVICE_BODY_CLOCK: 'device/DEVICE_BODY_CLOCK',
  GET_NIGHT_BY_NIGHT_DATA: 'device/GET_NIGHT_BY_NIGHT_DATA',
  GET_DEVICE_AVG_SLEEP_METRICS: 'device/GET_DEVICE_AVG_SLEEP_METRICS',
  CHANGE_DEVICE_NAME: 'device/CHANGE_DEVICE_NAME',
  RETURN_DEVICE: 'device/RETURN_DEVICE',
  GET_DEVICE_TRENDS: 'device/GET_DEVICE_TRENDS',
  LINK_PATIENT: 'device/LINK_PATIENT',
  GET_PATIENT_SESSION_DATES: 'device/GET_PATIENT_SESSION_DATES',
  GET_DEVICE_PATIENTS: 'device/GET_DEVICE_PATIENTS',
  SOCKET_DB_HANDLER: 'device/SOCKET_DB_HANDLER',
  GET_CLINIC_DEVICES: 'device/GET_CLINIC_DEVICES',
  GET_DEVICES: 'device/GET_DEVICES',
  GET_DEVICES_RECORDS: 'device/GET_DEVICES_RECORDS',
  UPDATE_DEVICES_RECORDS_STATUS: 'device/UPDATE_DEVICES_RECORDS_STATUS',
  GET_DEVICES_INVENTORY: 'device/GET_DEVICES_INVENTORY',
  UPDATE_DEVICES_INVENTORY_STATUS: 'device/UPDATE_DEVICES_INVENTORY_STATUS',
  GET_DEVICES_CONNECTION: 'device/GET_DEVICES_CONNECTION',
  GET_DEVICES_METRICS: 'device/GET_DEVICES_METRICS',
  ADD_SINGLE_DEVICE: 'device/ADD_SINGLE_DEVICE',
  ADD_MULTIPLE_DEVICE: 'device/ADD_MULTIPLE_DEVICE',
  REPLACE_DEVICES: 'device/REPLACE_DEVICES',
  REMOVE_DEVICE: 'device/REMOVE_DEVICE',
  CHANGE_DEVICE_ID: 'device/CHANGE_DEVICE_ID',
}

function isObject(value) {
  return value && typeof value === 'object' && value.constructor === Object
}

function getMyInIt(deviceID) {
  const checkObjorString = isObject(deviceID)

  let myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
    queryStringParameters: {
      // OPTIONAL
      device_id: deviceID,
    },
  }
  if (checkObjorString) {
    myInit = {
      // OPTIONAL
      headers: {}, // OPTIONAL
      queryStringParameters: deviceID,
    }
  }
  return myInit
}
function SleepStagesHistory(deviceID, date) {
  const checkObjorString = isObject(deviceID)

  let myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
    queryStringParameters: {
      // OPTIONAL
      device_id: deviceID,
      date_of_sleep: date,
    },
  }
  if (checkObjorString) {
    deviceID.date_of_sleep = date
    myInit = {
      // OPTIONAL
      headers: {}, // OPTIONAL
      queryStringParameters: deviceID,
    }
  }
  return myInit
}

export const deviceSetState = factorySetStateAction(actions.SET_STATE)

// API call to get a List of a Specified Device Activity
export const getDeviceActivity = async (deviceUID) =>
  http
    .get(apiPaths.Clinic.apiMainDeviceActivity, { device_uid: deviceUID }, {})
    .then((res) => res)
    .catch((err) => {
      window.log('deviceList', err)
      return []
    })

export const getClinicDeviceActivity = async (deviceUID) =>
  http
    .get(apiPaths.Clinic.apiNewDeviceActivity, { device_uid: deviceUID }, {})
    .then((res) => res)
    .catch((err) => {
      notification.error(`Something went wrong`, `Something went wrong ${err}`)
      return []
    })

// API call to add a new Device (SuperAdmin Only)
export const addDevice = (dataObj, role) =>
  http
    .post(apiPaths[role].apiDeviceCreate, dataObj, {})
    .then((res) => {
      notification.success({
        message: `Success`,
        description: 'Device created successfully',
      })
      return res // YQ: ???
    })
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return []
    })

// API call to update a specific Device (SuperAdmin Only)
export const updateDevice = (dataObj, role) =>
  http
    .post(apiPaths[role].apiDeviceUpdate, dataObj, {})
    .then((res) => {
      notification.success({
        message: `Success`,
        description: 'Device updated successfully',
      })
      return res // YQ: ?????
    })
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? err.response.data : err}`,
      )
      return []
    })

// API call to update a specific Device (SuperAdmin Only)
export const changeDeviceName = (dataObj, msg = 'Device name updated') =>
  http
    .post(apiPaths.Clinic.apiUpdateDeviceInfo, dataObj, {})
    .then((res) => {
      notification.success(`Success`, msg)
      return res
    })
    .catch((err) => {
      const { response } = err
      window.log('err', JSON.stringify(response))
      notification.error(
        `Something went wrong`,
        `${response && response.data ? err.response.data : err}`,
      )
      return []
    })

export const assignDeviceToProvider = (dataObj, role) =>
  http
    .post(apiPaths[role].apiDeviceAssign, dataObj, {})
    .then((res) => {
      notification.success(`Success`, 'Device Assigned successfully')
      return res
    })
    .catch((err) => {
      notification.error(`Something went wrong`, `Something went wrong ${err}`)
      return []
    })

// API call to add a specific Assigned Device back in Inventory (SuperAdmin Only)
export const addDeviceInInventory = (dataObj, role) =>
  http
    .post(apiPaths[role].apiDeviceAddInStock, dataObj, {})
    .then((res) => {
      notification.success(`Success`, 'Device updated successfully')
      return res
    })
    .catch((err) => {
      notification.error(
        `Something went wrong`,
        `${err.response && err.response.data ? err.response.data : err}`,
      )
      return []
    })

// API call to get a List of all the devices available in the current logged in Users Inventory
export const getAllInventoryDevices = async (role, adminID, status) =>
  http
    .get(
      apiPaths[role] ? apiPaths[role].apiDeviceDevices : '', // YQ: ?? emtpy string
      { status, admin_id: adminID },
      {},
    )
    .then((res) => res)
    .catch((err) => {
      window.log('deviceList', err)
      return []
    })

// API call to delete a specific Device
export const deleteDevice = (role, dataObj) =>
  http
    .post(apiPaths[role].apiDeviceDelete, dataObj, {})
    .then((res) => {
      notification.success(`Success`, 'Device deleted successfully')
      return res
    })
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return err
    })

/* CLINIC MANAGEMENT SYSTEM DEVICE PROFILE APIs */
export const getDeviceDetail = (deviceID = false) =>
  http
    .get(urls.deviceAPIs.deviceDetail, deviceID ? getMyInIt(deviceID) : '')
    .then((res) => res)
    .catch((err) => {
      window.log('device Details', err)
      return []
    })

export const getInventoryDevices = (payload) =>
  http
    .get(apiPaths.Clinic.apiClinicDevices, payload, {})
    .then((res) => res)
    .catch((err) => {
      window.log('inventory devices', err)
      return []
    })

export const getDashboardDevices = (deviceID = false) =>
  http
    .get(apiPaths.Clinic.dashboardDevices, deviceID ? getMyInIt(deviceID) : '')
    .then((res) => res)
    .catch((err) => {
      window.log('device Details', err)
      return { data: [] }
    })

export const getDeviceMetricsHistory = (data) =>
  http
    .get(urls.deviceAPIs.deviceMetricsHistory, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('Error in deviceMetricsHistory ', err)
      return []
    })

export const getTimeInBedData = (data) =>
  http
    .get(apiPaths.Clinic.apiTimeInBedData, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('getTimeInBedData error: ', err)
      return []
    })

export const returnDevice = (data) =>
  http
    .post(urls.deviceAPIs.returnDevice, data, {})
    .then((res) => {
      notification.success('Success', 'Device Removed Successfully')
      return res
    })
    .catch((err) => {
      const { response } = err
      notification.warning(
        'Something went wrong',
        `${response && response.data ? response.data : err}`,
      )
      window.log('returnDevice ', err)
      return {}
    })

export const getClinicDevices = (data) =>
  http
    .get(urls.deviceAPIs.deviceDetail, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('device Details', err)
      return []
    })

export const getDeviceSession = (deviceID, date = false) =>
  http
    .get(
      urls.deviceAPIs.deviceSession,
      date ? SleepStagesHistory(deviceID, date) : getMyInIt(deviceID),
    )
    .then((res) => res)
    .catch((err) => {
      const { response } = err
      window.log('error getDeviceSession', !response ? err : response)
      return {}
    })

export const getDeviceSessions = (deviceID) =>
  http
    .get(urls.deviceAPIs.allDeviceSessions, getMyInIt(deviceID))
    .then((res) => res)
    .catch((err) => {
      const { response } = err
      window.log('getDeviceSessions', !response ? err : response)
      return []
    })

// export const getLastSleepStagesHistory = (userUID) =>
//   http
//     .get(apiPaths.All.apiMemberSleepStages, { user_uid: userUID }, {})
//     .then((res) => res)
//     .catch((err) => {
//       const { response } = err
//       window.log('error getLastSleepStagesHistory', !response ? err : response)
//       return { status: 404 }
//     })

export const getDeviceAVGSleepMetrics = (memberID) =>
  http
    .get(apiPaths.All.apiAVGSLeepMetrics, { member_id: memberID }, {})
    .then((res) => res)
    .catch((err) => {
      window.log('AVG sleep metrcis error: ', err)
      return []
    })

export const getDeviceBodyClock = (dataObj) =>
  http
    .get('/clinic-sleep-session-dev/v1/circadianAnalysis', dataObj, {})
    .then((res) => {
      const { img } = res
      const { graph } = dataObj

      if (graph === 'process_c') {
        return res
      }
      if (img) {
        return img
      }

      return res
    })
    .catch((err) => {
      window.log('bodyclocktimeline', err)
      return {}
    })

export const linkPatient = (data) =>
  http
    .post(apiPaths.Clinic.apiAssignDevice, data, {})
    .then((res) => {
      notification.success(
        'Success',
        data.status === 0 ? 'Room removed from Resident' : `Resident Linked Successfully`,
      )
      return res
    })
    .catch((err) => {
      const { response } = err
      notification.warning(
        'Something went wrong',
        `${response && response.data ? response.data : err}`,
      )
      window.log('linkedPatient ', err)
      return {}
    })

export const getPatientSessions = async (data) =>
  http
    .get(urls.deviceAPIs.patientSessionsDate, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('getPatientSessions', err)
      return []
    })

export const getDevicePatientsList = async (data) =>
  http
    .get(urls.deviceAPIs.patientsList, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log('getDevicePatientList', err)
      return []
    })

export const changeDeviceStatus = async (data) =>
  new Promise((resolve) => {
    http
      .post(apiPaths.Clinic.apiClinicDevicesStatus, data, {})
      .then((res) => resolve(res))
      .catch((err) => {
        window.log(err)
        resolve([])
      })
  })

export const getAllDevices = (payload) => ({
  type: actions.GET_DEVICES,
  payload,
})

export const getDevicesRecords = (payload) => ({
  type: actions.GET_DEVICES_RECORDS,
  payload,
})

export const updateDevicesRecordsStatusAction = (payload) => ({
  type: actions.UPDATE_DEVICES_RECORDS_STATUS,
  payload,
})

export const updateDevicesInventoryStatusAction = (payload) => ({
  type: actions.UPDATE_DEVICES_INVENTORY_STATUS,
  payload,
})

export const getDevicesInventory = (payload) => ({
  type: actions.GET_DEVICES_INVENTORY,
  payload,
})

export const getDevicesConnection = (payload) => ({
  type: actions.GET_DEVICES_CONNECTION,
  payload,
})

export const getDevicesMetrics = (payload) => ({
  type: actions.GET_DEVICES_METRICS,
  payload,
})

export const addSingleDevice = (payload) => ({
  type: actions.ADD_SINGLE_DEVICE,
  payload,
})

export const addMultipleDevice = (payload) => ({
  type: actions.ADD_MULTIPLE_DEVICE,
  payload,
})

export const replaceDevices = (payload) => ({
  type: actions.REPLACE_DEVICES,
  payload,
})

export const removeDevice = (payload) => ({
  type: actions.REMOVE_DEVICE,
  payload,
})

export const changeDeviceId = (payload) => ({
  type: actions.CHANGE_DEVICE_ID,
  payload,
})

export default actions
